<template>
    <v-container class="mt-8 pb-12" style="max-width: 1000px;">
        <div class="mb-6">
            <h1 class="text-h4 font-weight-bold mb-1">Teams</h1>
            <p class="text-subtitle-1 grey--text mb-0">Browse task activity by team.</p>
        </div>

        <v-row v-if="teamRoles.length" dense>
            <v-col cols="12" sm="6" md="4" v-for="role in teamRoles" :key="role.id">
                <v-card outlined hover class="pa-4 team-card" @click="$router.push(`/team/${role.id}`)">
                    <v-icon color="primary" size="28" class="mb-2">mdi-account-multiple-outline</v-icon>
                    <div class="font-weight-bold">{{ role.name }}</div>
                </v-card>
            </v-col>
        </v-row>
        <div v-else class="text-center pa-8">
            <v-icon size="56" color="grey lighten-1">mdi-account-multiple-outline</v-icon>
            <div class="text-subtitle-1 grey--text mt-2">No teams found</div>
        </div>
    </v-container>
</template>

<script>
export default {
    name: 'TeamsComponent',
    inject: ['roles'],
    computed: {
        teamRoles() {
            const list = this.roles ? this.roles() || [] : [];
            return list.filter(r => r && r.id != null && r.name);
        },
    },
    mounted() {
        document.title = 'DG Tasks - Teams';
    },
};
</script>

<style scoped>
.team-card {
    border-radius: 10px;
    cursor: pointer;
}
</style>
